import { Grid } from "@material-ui/core";
import { activityPriceConfig, activityPriceFields, toggleOptions } from "./pricingConsts";
import { useStyles } from "./AddActivityPrice/AddActivityPriceStyles";
import { TenantNameResolver } from "features/saasManagement/TenantNameResolver/TenantNameResolver";

function ActivityPriceDialogContent({
    isLoading,
    activityPrice,
    onChange,
    vendors,
    lots,
    vehicleTypes,
    onChangeVehicleTypes,
    multiple,
    clients
}) {
    const classes = useStyles();

    return (
        <>
            {!(isLoading) &&
                <Grid container spacing={1} direction='column'>
                    <Grid item className={classes.field}>
                        {activityPriceConfig[activityPriceFields.ACTIVITY]?.component(activityPrice?.activityItemId, (val) => onChange("activityItemId", val))}
                    </Grid>
                    <Grid item className={classes.field}>
                        {activityPriceConfig[activityPriceFields.CLIENT]?.component(activityPrice?.clientId, clients ?? [], (val) => onChange("clientId", val), false, "Client")}
                    </Grid>
                    <Grid item className={classes.field}>
                        {activityPriceConfig[activityPriceFields.VENDOR]?.component(activityPrice?.vendorId, vendors, (val) => onChange("vendorId", val), true, "Vendor", multiple)}
                    </Grid>
                    <Grid item className={classes.field}>
                        {activityPriceConfig[activityPriceFields.LOT_OPTIONS]?.component(activityPrice?.priceAppliesTo, null, (event) => onChange("priceAppliesTo", event.target.value), true, "Select an option for the activity price to apply to")}
                    </Grid>
                    {activityPrice?.priceAppliesTo == toggleOptions.SPECIFIC_LOTS &&
                        <Grid item className={classes.field}>
                            {activityPriceConfig[activityPriceFields.LOT_TOGGLE]?.component(activityPrice?.includeNonTenant, (event) => onChange("includeNonTenant", event.target.checked), <TenantNameResolver startText="Include Non" endText="Lots" />)}
                        </Grid>
                    }
                    {activityPrice?.priceAppliesTo == toggleOptions.SPECIFIC_LOTS &&
                        <Grid item className={classes.field}>
                            {activityPriceConfig[activityPriceFields.LOT]?.component(activityPrice?.lotId, lots, (val) => onChange("lotId", val), true, "Lot", multiple, !activityPrice?.includeNonTenant)}
                        </Grid>
                    }
                    <Grid item className={classes.field}>
                        {activityPriceConfig[activityPriceFields.VEHICLE_TYPES]?.component(activityPrice?.vehicleTypeIdsList ?? (activityPrice?.id ? [null] : []), [{ name: 'All vehicle types', id: null }, ...(vehicleTypes ?? [])], (val) => onChangeVehicleTypes(val), false, "Vehicle Types")}
                    </Grid>
                    <Grid item className={classes.checkbox}>
                        {activityPriceConfig[activityPriceFields.NOT_SUPPORTED]?.component(activityPrice?.notSupported, (val) => onChange("notSupported", val.target.checked), "Vendor doesn’t offer this combination")}
                    </Grid>
                    <Grid item className={classes.field}>
                        {activityPriceConfig[activityPriceFields.PRICE]?.component(activityPrice?.price, null, (val) => onChange("price", val?.split('.')?.[1]?.length > 1 ? Number(val)?.toFixed(2) : val), !activityPrice?.notSupported, "Price")}
                    </Grid>
                    <Grid item className={classes.checkbox}>
                        {activityPriceConfig[activityPriceFields.USE_INVENTORY]?.component(activityPrice?.useInventory, (val) => onChange("useInventory", val.target.checked), "Uses Inventory?")}
                    </Grid>
                </Grid>
            }
        </>
    )
}

export default ActivityPriceDialogContent;